import { render, staticRenderFns } from "./EditOrganDialog.vue?vue&type=template&id=f882a538&scoped=true&"
import script from "./EditOrganDialog.vue?vue&type=script&lang=js&"
export * from "./EditOrganDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditOrganDialog.vue?vue&type=style&index=0&id=f882a538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f882a538",
  null
  
)

export default component.exports